export default __webpack_public_path__ + "static/img/info-circle.f8e515d.png";